import { useContext } from 'react';
import FormikSelectInput from '../../../components/Input/FormikSelectInput';
import { MojeIdContext } from '../../../context/MojeIdContext';

interface SelectIdentificatorTypeProps {
    countryCode: string;
    name: string;
    label: string;
    disabled?: boolean;
    required?: boolean;
}

export const SelectIdentificatorType = ({ countryCode, ...props }: SelectIdentificatorTypeProps) => {
    const { initData } = useContext(MojeIdContext);

    const assocs = (initData?.SubjectIdentificationConfigurationCitizenshipAssocs || []).filter(
        (a: any) => a.CitizenshipCountryCode === countryCode
    );
    const options = (initData?.SubjectIdentificationConfigurations || []).filter((a: any) =>
        assocs.find((ass: any) => ass.SubjectIdentificationConfigurationCode === a.Code)
    );

    return (
        <FormikSelectInput
            isCenter
            options={options.map((ident: any) => ({
                value: ident.SubjectIdentificationTypeCode,
                label: ident.DisplayNameTranslated,
            }))}
            {...props}
        />
    );
};
